



































































import { defineComponent } from '@nuxtjs/composition-api'
import { concatUrl } from '~/utils/string'
import { toSnakeCase } from '~/utils/snake-case'
import CGoogleRating from '~/components/shared/configurable/rating/CGoogleRating.vue'
import ListItemVehicleButton from '~/components/car/dealers/map/list/item/ListItemVehicleButton'
import ListItemInfo from '~/components/car/dealers/map/list/item/ListItemInfo'

export default defineComponent({
  components: {
    CGoogleRating,
    ListItemVehicleButton,
    ListItemInfo
  },
  props: {
    dealer: { type: Object, required: true },
    showAvatar: { type: Boolean, default: false },
    customClass: {
      type: String,
      required: false,
      default: null
    },
    iconsNextToDealersName: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showReplyForm: false,
    visited: false
  }),
  computed: {
    formattedDealerPageUrl() {
      return concatUrl(this.dealer.pageUrl, 'bl=1')
    },
    dealerToSnakeCase() {
      return toSnakeCase(this.dealer)
    }
  },
  methods: {
    setHoveredDealer() {
      this.$store.commit('dealers/map/SET_HOVERED_DEALER', this.dealer)
    },
    removeHoveredDealer() {
      this.$store.commit('dealers/map/SET_HOVERED_DEALER', null)
    },
    setActiveDealer(event) {
      // special handling for cases where the user has clicked on an anchor tag, we dont need to set this dealer as
      // active
      const path = event.composedPath ? event.composedPath() : event.path
      const clickedOnLink = path?.some(element => element.localName === 'a')
      if (!clickedOnLink) {
        this.$store.commit('dealers/map/TOGGLE_MOBILE_LIST_VISIBLE')
        this.$store.commit('dealers/map/SET_ACTIVE_DEALER', this.dealer)
      }
    }
  }
})
